import { MultiselectInputDefaultIcons } from './components/MultiselectInputDefaultIcons';
import { MultiselectItem } from './components/MultiselectItem';
import { MultiselectItemCheckbox } from './components/MultiselectItemCheckbox';
import { MultiselectPopoverContent } from './components/MultiselectPopoverContent';
import { MultiselectRoot } from './components/MultiselectRoot';
import { MultiselectInput } from './MultiselectInput';
export * from './MultiselectInput.types';

export const Multiselect = {
  Root: MultiselectRoot,
  PopoverContent: MultiselectPopoverContent,
  Item: MultiselectItem,
  ItemCheckbox: MultiselectItemCheckbox,
  Input: MultiselectInput,
  InputDefaultIcons: MultiselectInputDefaultIcons,
};
